import "./ColsEditor.0.css";
import { DataForm } from '@tencent/data-schema/lib/vue-ui/DataForm';
const __script_base__ = {
  name: 'ColsEditor',
  components: {
    DataForm
  },
  props: {
    fields: Array,
    // array of dataschema
    value: Array
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  computed: {
    valueSchema() {
      return {
        type: 'array',
        items: {
          type: 'object',
          fields: [{
            id: 'id',
            title: '',
            type: 'string',
            required: true,
            enum: this.fields.map(x => ({
              label: x.title || x.id,
              value: x.id
            }))
          }, {
            id: 'title',
            title: '标题',
            type: 'string'
          }, {
            id: 'width',
            title: '宽度',
            type: 'string',
            examples: [{
              value: '300px'
            }]
          }, {
            id: 'readonly',
            title: '只读',
            type: 'boolean',
            examples: [{
              value: true
            }]
          }, {
            id: 'description',
            title: '说明',
            type: 'string'
          }]
        }
      };
    }
  },
  methods: {
    handleChange(val) {
      this.$emit('change', val);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "colsEditor"
  }, [_c('DataForm', {
    attrs: {
      "schema": _vm.valueSchema,
      "value": _vm.value
    },
    on: {
      "change": _vm.handleChange
    }
  })], 1);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Field/comps/ColsEditor.vue",
  "_scopeId": "data-v-25e05b8c"
}, typeof __script__ === 'function' ? __script__.options : __script__);